export type MockRole = 'platform_owner' | 'super_admin' | 'admin' | 'member';

export function isDevBypass(): boolean {
  return (
    import.meta.env.DEV === true &&
    import.meta.env.VITE_DEV_BYPASS_AUTH === 'true'
  );
}

function getMockRole(): MockRole {
  const role = import.meta.env.VITE_DEV_MOCK_ROLE;
  if (role === 'platform_owner' || role === 'admin' || role === 'member') return role;
  return 'super_admin';
}

export const devUser = {
  id: '00000000-0000-0000-0000-000000000001',
  auth_id: '00000000-0000-0000-0000-000000000001',
  email: 'dev@otto.local',
  full_name: 'Dev User',
  display_name: 'Dev',
  avatar_url: '',
  phone: '',
  job_title: 'Developer',
  department: 'Engineering',
  platform_role: getMockRole(),
  status: 'active' as const,
  invited_by: null,
  last_login_at: new Date().toISOString(),
  metadata: {},
  is_active: true,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};

export const devSession = {
  access_token: 'dev-bypass-token',
  token_type: 'bearer',
  expires_in: 86400,
  refresh_token: 'dev-bypass-refresh',
  user: {
    id: devUser.auth_id,
    email: devUser.email,
    app_metadata: {},
    user_metadata: { full_name: devUser.full_name },
    aud: 'authenticated',
    created_at: devUser.created_at,
  },
};

export const devModuleAccess = [
  { id: 'dev-access-home', user_id: devUser.id, module_key: 'home', access_level: 'full', is_active: true },
  { id: 'dev-access-wb', user_id: devUser.id, module_key: 'wb', access_level: 'full', is_active: true },
  { id: 'dev-access-tb', user_id: devUser.id, module_key: 'tb', access_level: 'full', is_active: true },
  { id: 'dev-access-sm', user_id: devUser.id, module_key: 'sm', access_level: 'full', is_active: true },
  { id: 'dev-access-tm', user_id: devUser.id, module_key: 'tm', access_level: 'full', is_active: true },
  { id: 'dev-access-ad', user_id: devUser.id, module_key: 'ad', access_level: 'full', is_active: true },
  { id: 'dev-access-lb', user_id: devUser.id, module_key: 'lb', access_level: 'full', is_active: true },
  { id: 'dev-access-br', user_id: devUser.id, module_key: 'br', access_level: 'full', is_active: true },
  { id: 'dev-access-ee', user_id: devUser.id, module_key: 'ee', access_level: 'full', is_active: true },
  { id: 'dev-access-core', user_id: devUser.id, module_key: 'core', access_level: 'full', is_active: true },
  { id: 'dev-access-io', user_id: devUser.id, module_key: 'io', access_level: 'full', is_active: true },
  { id: 'dev-access-hd', user_id: devUser.id, module_key: 'hd', access_level: 'full', is_active: true },
  { id: 'dev-access-cs', user_id: devUser.id, module_key: 'cs', access_level: 'full', is_active: true },
];
